module.exports = __webpack_public_path__ + "img/xp.eec4de5e.svg";